import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth.js";
import { SkeletonList } from "../components/ui/index.js";
export function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (_jsx("div", { style: { padding: 24 }, children: _jsx(SkeletonList, { rows: 3 }) }));
    }
    // Preserve the requested location so LoginPage can return the user here after
    // authenticating, instead of always dropping them on the dashboard.
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location } });
    return _jsx(_Fragment, { children: children });
}
